// Module
var code = "<input type=checkbox name=headerDeletionCB style=margin-top:3px;margin-left:3px ng-disabled=\"!enableDeletionCheckbox || forbidDeletion\" ng-if=canEditOrdersPermission() ng-click=toggleAll() ng-checked=allChildrenChecked() ng-model=model.headerCheck> ";
// Exports
module.exports = code;